export default "__VITE_ASSET__BpblLOuo__"